import styled from 'styled-components'
import media from 'styled-media-query'

export const TemplateStyled = styled.main`
  * {
    letter-spacing: 0.05rem;
  }

  button {
    align-items: center;
    background: ${({ theme }) => theme.colors.second};
    border-radius: 5px;
		color: ${({ theme }) => theme.colors.text.light};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 13px;
    line-height: 19px;
    border: 0px;
    padding: 0.5rem;

    &.rmvbtn {
      background: ${({ theme }) => theme.colors.main};
      color: ${({ theme }) => theme.colors.second};
      font-weight: 600;
    }
	}
`

export const MainStyled = styled.main`
	display: flex;
	flex-direction: column;
	min-height: calc(100vh - 180px);

  ${media.lessThan('medium')`
    padding: 0;
  `}
`
